import fslightbox from 'fslightbox';
import Swiper from 'swiper';

const mediaSliderElements = document.querySelectorAll('.swiper-media-gallery .swiper-container');
const mediaSliderHeight = 330;

const _initMediaSlider = (sliderRoot) => {
  const slides = sliderRoot.querySelectorAll('.swiper-slide');
  const count = slides.length
  const lessThanThree = count < 3
  const lessThanTwo = count < 2

  const params = {
    slidesPerView: 'auto',
    centeredSlides: lessThanTwo,
    loop: !lessThanThree,
    watchOverflow: lessThanThree,
    ...(!lessThanTwo && {
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        type: 'bullets',
      },
    }),
    spaceBetween: 20,
  };

  if (lessThanThree) {
    sliderRoot.closest('.swiper-media-gallery').classList.add('container--narrow');
  } else {
    sliderRoot.closest('.swiper-media-gallery').classList.remove('container--narrow');
  }

  slides.forEach((slide) => {
    let slideImage = slide.querySelector('.media-gallery__thumbnail');
    slide.style.width = `${(parseInt(slideImage.dataset.originalWidth) * mediaSliderHeight) / parseInt(slideImage.dataset.originalHeight)}px`;
  });

  const swiper = new Swiper(sliderRoot, params);
};



if (mediaSliderElements.length) {

  mediaSliderElements.forEach((slider) => {
    let slideItems = [];

    slider.querySelectorAll('.swiper-slide').forEach((slide) => {
      slideItems.push(slide); //create array for all slide-items before swiper is initialized with all slide-duplicates
    });

    _initMediaSlider(slider);

    slider.querySelectorAll('.swiper-slide-duplicate').forEach((duplicate) => {
      duplicate.addEventListener('click', (event) => {
        event.preventDefault();
        slideItems[duplicate.getAttribute('data-swiper-slide-index')].click(); //duplicates should be clicked like original item
      })
    })

  });

}
